import { Environments } from '@/config';
import { TRIHEALTH_PRODUCTION } from './trihealth.production';
import { TRIHEALTH_STAGING } from './trihealth.staging';

export const TRIHEALTH = import.meta.env.MODE === Environments.PROD ? TRIHEALTH_PRODUCTION : TRIHEALTH_STAGING;
